/* ═══════════════════════════════════════════════════════════
   CLOVERMEW THEME — theme.js
   Cart drawer · Quick add · Mobile menu · Sticky header
═══════════════════════════════════════════════════════════ */

/* ── Sticky header ── */
const header = document.querySelector('.cm-header');
if (header) {
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });
}

/* ── Mobile menu ── */
const hamburger = document.querySelector('.cm-hamburger');
const mobileMenu = document.querySelector('.cm-mobile-menu');
const mobileClose = document.querySelector('.cm-mobile-close');

if (hamburger && mobileMenu) {
  hamburger.addEventListener('click', () => {
    mobileMenu.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
}
if (mobileClose && mobileMenu) {
  mobileClose.addEventListener('click', () => {
    mobileMenu.classList.remove('open');
    document.body.style.overflow = '';
  });
}

/* ── Cart Drawer ── */
const cartDrawer   = document.querySelector('.cm-cart-drawer');
const drawerOverlay = document.querySelector('.cm-drawer-overlay');
const cartClose    = document.querySelector('.cm-cart-close');
const cartBtns     = document.querySelectorAll('[data-open-cart]');

function openCart() {
  if (!cartDrawer) return;
  cartDrawer.classList.add('open');
  drawerOverlay?.classList.add('open');
  document.body.style.overflow = 'hidden';
  fetchCart();
}
function closeCart() {
  cartDrawer?.classList.remove('open');
  drawerOverlay?.classList.remove('open');
  document.body.style.overflow = '';
}

cartBtns.forEach(btn => btn.addEventListener('click', openCart));
cartClose?.addEventListener('click', closeCart);
drawerOverlay?.addEventListener('click', closeCart);

/* ── Fetch cart & render ── */
async function fetchCart() {
  const body = document.querySelector('.cm-cart-drawer-body');
  const foot = document.querySelector('.cm-cart-drawer-foot');
  if (!body) return;

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCartDrawer(cart, body, foot);
    updateCartCount(cart.item_count);
  } catch(e) {
    console.error('Cart fetch error', e);
  }
}

function renderCartDrawer(cart, body, foot) {
  if (!cart.items.length) {
    body.innerHTML = `
      <div class="cm-cart-empty">
        <div class="cm-cart-empty-icon">🛒</div>
        <p>Your cart is empty</p>
        <a href="/collections/all" class="cm-btn cm-btn-primary cm-btn-sm" onclick="closeCart()">Shop Now</a>
      </div>`;
    if (foot) foot.style.display = 'none';
    return;
  }

  if (foot) foot.style.display = '';

  body.innerHTML = cart.items.map(item => `
    <div class="cm-cart-item" data-key="${item.key}">
      <div class="cm-cart-item-img">
        <img src="${item.image || ''}" alt="${item.title}" loading="lazy">
      </div>
      <div class="cm-cart-item-info">
        <div class="cm-cart-item-title">${item.product_title}</div>
        ${item.variant_title && item.variant_title !== 'Default Title'
          ? `<div class="cm-cart-item-variant">${item.variant_title}</div>` : ''}
        <div class="cm-cart-item-price">${formatMoney(item.final_line_price)}</div>
        <div class="cm-cart-item-actions">
          <div class="cm-cart-item-qty">
            <button class="cm-cart-item-qty-btn" data-action="decrease" data-key="${item.key}">−</button>
            <span class="cm-cart-item-qty-num">${item.quantity}</span>
            <button class="cm-cart-item-qty-btn" data-action="increase" data-key="${item.key}">+</button>
          </div>
          <span class="cm-cart-item-remove" data-key="${item.key}">Remove</span>
        </div>
      </div>
    </div>`).join('');

  const subtotalEl = document.querySelector('.cm-cart-subtotal span:last-child');
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

  body.querySelectorAll('.cm-cart-item-qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      const item = cart.items.find(i => i.key === key);
      if (!item) return;
      const newQty = btn.dataset.action === 'increase' ? item.quantity + 1 : item.quantity - 1;
      await updateCartItem(key, newQty);
    });
  });

  body.querySelectorAll('.cm-cart-item-remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      await updateCartItem(btn.dataset.key, 0);
    });
  });
}

async function updateCartItem(key, qty) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    const cart = await res.json();
    const body = document.querySelector('.cm-cart-drawer-body');
    const foot = document.querySelector('.cm-cart-drawer-foot');
    renderCartDrawer(cart, body, foot);
    updateCartCount(cart.item_count);
  } catch(e) { console.error('Cart update error', e); }
}

function updateCartCount(count) {
  document.querySelectorAll('.cm-cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

/* ── Add to Cart ── */
async function addToCart(variantId, qty = 1, btn = null) {
  if (btn) {
    btn.disabled = true;
    const orig = btn.innerHTML;
    btn.innerHTML = '<span class="loading-spinner"></span>';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      showToast('Added to cart!', 'success');
      openCart();
    } catch(e) {
      showToast('Something went wrong', '');
    } finally {
      btn.disabled = false;
      btn.innerHTML = orig;
    }
  } else {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    showToast('Added to cart!', 'success');
    openCart();
  }
}

/* ── Quick Add ── */
document.querySelectorAll('.cm-quick-add-btn').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (variantId) addToCart(variantId, 1, btn);
  });
});

/* ── Product page ATC ── */
const productForm = document.querySelector('.cm-product-form');
if (productForm) {
  const atcBtn = productForm.querySelector('.cm-atc-btn');
  const qtyInput = productForm.querySelector('.cm-qty-input');
  const buyNowBtn = productForm.querySelector('.cm-buy-now-btn');
  const variantSelect = productForm.querySelector('[name="id"]');

  atcBtn?.addEventListener('click', () => {
    const variantId = variantSelect?.value;
    const qty = parseInt(qtyInput?.value || '1');
    if (variantId) addToCart(variantId, qty, atcBtn);
  });

  buyNowBtn?.addEventListener('click', () => {
    const variantId = variantSelect?.value;
    const qty = parseInt(qtyInput?.value || '1');
    if (variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      }).then(() => { window.location.href = '/checkout'; });
    }
  });

  /* Quantity buttons */
  productForm.querySelectorAll('.cm-qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.cm-qty').querySelector('.cm-qty-input');
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'increase') val = Math.min(val + 1, 99);
      if (btn.dataset.action === 'decrease') val = Math.max(val - 1, 1);
      input.value = val;
    });
  });

  /* Variant buttons — resolve the FULL option combination to a real variant.
     (Previously each button carried an empty data-variant-id, so clicking any
     color/style swatch silently wiped the hidden select's value and Add to
     Cart / Buy Now stopped doing anything. Fixed by matching the clicked
     option-value combination against the product's real variant list, then
     keeping price/compare/savings/availability in sync with the match.) */
  const variantDataEl = document.getElementById('product-variants-json') || productForm.querySelector('[data-product-variants]');
  const productVariants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
  const variantGroups = productForm.querySelectorAll('.cm-variant-btns');
  const unavailableMsg = productForm.querySelector('.cm-variant-unavailable-msg');
  const priceEl = document.getElementById('product-price');
  const compareEl = productForm.closest('.cm-product-details')?.querySelector('.cm-product-page-price .compare');
  const saveBadgeEl = productForm.closest('.cm-product-details')?.querySelector('.cm-product-page-price .save-badge');

  function formatDollars(amount) {
    return '$' + Number(amount).toFixed(2);
  }

  // Seed selection state from whichever button starts .active in each option group
  const selectedOptions = [];
  variantGroups.forEach(group => {
    const activeBtn = group.querySelector('.cm-variant-btn.active') || group.querySelector('.cm-variant-btn');
    if (!activeBtn) return;
    selectedOptions[parseInt(activeBtn.dataset.optionIndex, 10)] = activeBtn.dataset.optionValue;
  });

  function findVariant(options) {
    return productVariants.find(v => {
      const vOpts = [v.option1, v.option2, v.option3];
      return options.every((val, i) => val === undefined || vOpts[i] === val);
    });
  }

  function applyVariant(variant) {
    if (!variant) {
      if (unavailableMsg) unavailableMsg.style.display = 'block';
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
      if (buyNowBtn) buyNowBtn.disabled = true;
      return;
    }
    if (unavailableMsg) unavailableMsg.style.display = 'none';
    if (variantSelect) variantSelect.value = variant.id;

    if (priceEl) priceEl.textContent = formatDollars(variant.price);
    const onSale = variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price);
    if (compareEl) {
      compareEl.style.display = onSale ? '' : 'none';
      if (onSale) compareEl.textContent = formatDollars(variant.compare_at_price);
    }
    if (priceEl) priceEl.classList.toggle('cm-price-sale', !!onSale);
    if (saveBadgeEl) {
      if (onSale) {
        const pct = Math.round((1 - parseFloat(variant.price) / parseFloat(variant.compare_at_price)) * 100);
        saveBadgeEl.textContent = `Save ${pct}%`;
        saveBadgeEl.style.display = '';
      } else {
        saveBadgeEl.style.display = 'none';
      }
    }

    const outOfStock = !variant.available;
    if (atcBtn) { atcBtn.disabled = outOfStock; atcBtn.textContent = outOfStock ? 'Sold Out' : 'Add to Cart'; }
    if (buyNowBtn) buyNowBtn.disabled = outOfStock;
  }

  productForm.querySelectorAll('.cm-variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.cm-variant-btns');
      group.querySelectorAll('.cm-variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      selectedOptions[parseInt(btn.dataset.optionIndex, 10)] = btn.dataset.optionValue;
      applyVariant(findVariant(selectedOptions));
    });
  });

  /* Gallery thumbs */
  document.querySelectorAll('.cm-gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.querySelector('img')?.src;
      const mainImg = document.querySelector('.cm-gallery-main img');
      if (mainImg && src) mainImg.src = src;
      document.querySelectorAll('.cm-gallery-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* Sticky ATC on scroll */
  const stickyAtc = document.querySelector('.cm-sticky-atc');
  const atcRow = document.querySelector('.cm-atc-row');
  if (stickyAtc && atcRow) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        stickyAtc.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-80px' });
    observer.observe(atcRow);

    stickyAtc.querySelector('.cm-sticky-atc-btn')?.addEventListener('click', () => {
      const variantId = variantSelect?.value;
      const qty = parseInt(qtyInput?.value || '1');
      if (variantId) addToCart(variantId, qty);
    });
  }
}

/* ── Accordion ── */
document.querySelectorAll('.cm-accordion-trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const body = trigger.nextElementSibling;
    const isOpen = body.classList.contains('open');
    trigger.parentElement.closest('.cm-product-details, .cm-page-content')
      ?.querySelectorAll('.cm-accordion-body').forEach(b => b.classList.remove('open'));
    trigger.parentElement.closest('.cm-product-details, .cm-page-content')
      ?.querySelectorAll('.cm-accordion-trigger').forEach(t => t.classList.remove('active'));
    if (!isOpen) {
      body.classList.add('open');
      trigger.classList.add('active');
    }
  });
});

/* ── Newsletter form ── */
const newsletterForm = document.querySelector('.cm-newsletter-form');
if (newsletterForm) {
  newsletterForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = newsletterForm.querySelector('input[type="email"]')?.value;
    if (!email) return;
    const btn = newsletterForm.querySelector('button');
    btn.textContent = 'Subscribing...';
    btn.disabled = true;
    try {
      await fetch('/contact#contact_form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `form_type=customer&email=${encodeURIComponent(email)}&tags=newsletter`
      });
      showToast('You\'re on the list!', 'success');
      newsletterForm.reset();
    } catch(e) { /* silent */ } finally {
      btn.textContent = 'Subscribe';
      btn.disabled = false;
    }
  });
}

/* ── Discount code (cart page) ── */
const discountApply = document.querySelector('.cm-apply-discount');
if (discountApply) {
  discountApply.addEventListener('click', () => {
    const code = document.querySelector('.cm-discount-code')?.value?.trim();
    if (code) showToast('Apply code at checkout', '');
  });
}

/* ── Toast ── */
let toastTimer;
function showToast(msg, type) {
  let toast = document.querySelector('.cm-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'cm-toast';
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.className = `cm-toast${type ? ' ' + type : ''}`;
  void toast.offsetWidth;
  toast.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('show'), 3000);
}

/* ── Money formatter ── */
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/* ── Init cart count on load ── */
fetch('/cart.js')
  .then(r => r.json())
  .then(cart => updateCartCount(cart.item_count))
  .catch(() => {});
